import React from "react";
import "../OrderSuccess.css";
import {
  FaHeart,
  FaHeadset,
  FaUtensils,
  FaShieldAlt,
} from "react-icons/fa";

const FooterMessage = () => {
  return (
    <div className="footer-message">

      <div className="footer-heart">

        <FaHeart />

      </div>

      <h2>Thank You for Choosing HomeFoods!</h2>

      <p className="footer-description">
        Your order has been successfully placed.
        <br />
        Our home chef is preparing your food with
        fresh ingredients, care, and love.
      </p>

      <div className="footer-features">

        <div className="footer-feature">

          <FaUtensils />

          <span>Freshly Prepared</span>

        </div>

        <div className="footer-feature">

          <FaShieldAlt />

          <span>Safe & Hygienic</span>

        </div>

        <div className="footer-feature">

          <FaHeadset />

          <span>24×7 Customer Support</span>

        </div>

      </div>

      <div className="footer-bottom">

        ❤️ Homemade with Love.
        <br />
        🚀 Delivered with Care.

      </div>

    </div>
  );
};

export default FooterMessage;